import { SelectProps } from 'antd/lib'
import { useMemo } from 'react'

import { useClassifierServiceGetCategoryListEndpoint } from 'src/api/queries'
import { Select } from 'src/components'
import { useDefaultSortingItem } from 'src/hooks'
import { useLocales } from 'src/locales'

type Props = {
  hasDefault?: boolean
} & SelectProps

export const CategorySelect = ({ hasDefault = true, ...props }: Props) => {
  const { t } = useLocales()
  const { defaultSortingOption } = useDefaultSortingItem()

  const { data, isLoading } = useClassifierServiceGetCategoryListEndpoint()

  const categoryOptions = useMemo(() => {
    const options = data?.data?.map((category) => ({
      value: category,
      label: category
    }))

    if (hasDefault) return [defaultSortingOption, ...(options || [])]

    return options
  }, [data])

  return (
    <Select
      loading={isLoading}
      placeholder={t('classifiers.category')}
      options={categoryOptions}
      {...props}
    />
  )
}
